module.exports = __webpack_public_path__ + "title-2.svg?8af369a1d62aeb83cb8cccf648abe80a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/title-2.svg
// module id = 99
// module chunks = 0